/* Starter Theme — Premium UX : scroll reveal (vanilla JS) */
(function () {
  var d = document;
  d.documentElement.classList.add('mg-anim');

  function ready(fn) {
    if (d.readyState !== 'loading') { fn(); }
    else { d.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    /* --- Scroll reveal --- */
    var sel = '.index-sections > div, .collection-grid .grid__item, .product-block, .product-loop, [data-mg-reveal]';
    var targets = Array.prototype.slice.call(d.querySelectorAll(sel));
    targets.forEach(function (el) { el.classList.add('mg-reveal'); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
      targets.forEach(function (el) { io.observe(el); });
    } else {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* La barre sticky « ajouter au panier » est gérée par snippets/zz-sticky-atc.liquid (zz-satc) — ne pas dupliquer ici. */
  });
})();
